import React from 'react';
import ReactQueryParams from "react-query-params";
import {Col, Button, Row, Badge, ButtonToolbar} from 'reactstrap';

import * as TextManager from "../../../modules/languages/TextManager";
import * as environment from "../../../modules/environment";
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import Alert from '../../../components/Alert';
import {round10} from "../../../modules/common"

class EquipOrderManagerProfit extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            warning: '',
            error: false,
            saved: false,
            success: false,

            comment: "",
            files_front: props.itemOrderInEdit.payment.payType === 2 ? [[{preview: environment.getServerBasePath() + '/equip/equip_order_download?equipID=' + props.itemOrderInEdit.id + '&side=front'}]] : [[]],
            filesBase64_front: [[]],
            filesInfo_front: [{}],

            files_rear: props.itemOrderInEdit.payment.payType === 2 ? [[{preview: environment.getServerBasePath() + '/equip/equip_order_download?equipID=' + props.itemOrderInEdit.id + '&side=rear'}]] : [[]],
            filesBase64_rear: [[]],
            filesInfo_rear: [{}]
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchSalesDataIfNeeded());
    }


    render() {



        return (

            <div className="catalog-items__wrap">
                {this.state.warning !== '' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span style={{float: 'right'}}
                                 className='bold-text'>{this.state.warning}</span>
                        </p>
                    </Alert>
                </Row>}
                {this.state.error &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }


                <div className="catalog-items" style={{paddingRight: '50px'}}>
                    <style>
                        {`
                        .catalog-item {
                        width: calc(20% - 47px);
                        }
                        .catalog-item__img-wrap {
                        height: auto
                        }
                    `}
                    </style>
                    {this.props.itemOrderInEdit.orders.map((order, i) => {

                        let profitStr = 'רווח ';

                        let tmp = parseFloat(order.price) * (parseFloat(order.profit) * 0.01);

                        let profit = round10(tmp/2, -1);

                        profitStr = "₪" + profitStr + profit;

                        return (
                            <div className="catalog-item" key={i}
                                 style={{padding: '10px 10px', height: '250', marginRight: '10px'}}>
                                <div className="catalog-item__img-wrap">
                                    <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                         src={environment.getServerBasePath() + '/equip/equip_download?equipID=' + order.equipId}
                                         alt="catalog-item-img"/>
                                </div>
                                <div className="catalog-item__info">
                                    <h5 className="catalog-item__title"
                                        style={{textAlign: 'center'}}>{order.equipName}</h5>
                                    <h5 className="catalog-item__title">{order.serialNum}</h5>
                                    <h5 className="catalog-item__title">{order.text}</h5>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    <span className="form__form-group-label" style={{paddingLeft: '10px'}}>
                                        {profitStr}
                                    </span>
                                </div>
                            </div>
                        )
                    })
                    }
                </div>

                {/*<div className='card__title' style={{paddingRight: '50px'}}>
                    <h4 className='bold-text'>price</h4>
                </div>*/}

                <ButtonToolbar className="form__button-toolbar" style={{flexDirection: 'row-reverse'}}>
                    <Button type="button" onClick={this.props.onClose} style={{marginRight: '20px'}}>
                        לסגור
                    </Button>
                </ButtonToolbar>
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        itemOrderInEdit: state.equipment.itemOrderInEdit,
        equipStore: state.equipment.data.equipStore,
        status: state.sales.status,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(EquipOrderManagerProfit))